import "./index.css";
import infoIcon from "../../../../../assets/design-revamp-company/company-detail-headers/company-total-info-icon.svg";
import TipBox from "../../../../../components/TipBox";

// // Custom hook to handle clicks outside of the tooltip
// const useOutsideClick = (callback) => {
//   const ref = useRef();

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (ref.current && !ref.current.contains(event.target)) {
//         callback();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [callback]);

//   return ref;
// };

const InfoIcon = ({ text }) => {
  return (
    <TipBox title={"Tip"} message={text}>
      <div className="info-icon-container">
        <img src={infoIcon} alt="Info Icon" className="info-icon" />
      </div>
    </TipBox>
  );
};

export default InfoIcon;
